import {buildStateEvent, GenericStateEvent} from '../../common-redux'
import {SupportTeam} from './model'

export interface SupportTeamStateEvent<T> extends GenericStateEvent<T> {}

export const GetAllSupportTeamWithDeleteGroupSuccessEvent = {
    type: 'GetAllSupportTeamWithDeleteGroupSuccessEvent',
    build: (payload: SupportTeam[]) => buildStateEvent(GetAllSupportTeamWithDeleteGroupSuccessEvent.type, payload)
}
